import $ from 'jquery';

/**
 * Front page slider
 */

function Slider(el) {
  this.$el = $(el);

  this.$slides = this.$el.find('.js-slide');
  this.$slides.hide().first().show();

  this.$back = this.$el.find('.js-back');
  this.backIsVisible = true;
  this.$forward = this.$el.find('.js-forward');
  this.forwardIsVisible = false;

  this.isAnimating = false;
  this.duration = Modernizr.csstransforms ? 500 : 0;
  this.easing = 'easeOutCubic';

  this.currentSlide = 0;
  this.totalSlides = this.$slides.length;
  this.updateState(true, true);

  var self = this;

  // Vertical align
  if ("fit" in window) {
    this.$slides.find('.intro-card').hide();
    this.$slides.each(function () {
      var centerOuter = $(this).find('.inner-block'),
          centerInner = $(this).find('.intro-card')

      if (centerOuter.length > 0 && centerInner.length > 0) {
        $(window).on('load', function () {
          centerInner.show();
        });
      }
    });
  }

  this.$back.on('click', function (ev) {
    ev.preventDefault();
    self.goBack();
  });

  this.$forward.on('click', function (ev) {
    ev.preventDefault();
    self.goForward();
  });

  $(document).on('keydown', function (ev) {
    switch (ev.keyCode) {
    case 37:
      if (self.currentSlide > 0) {
        self.goBack();
      }
      break;
    case 39:
      if (self.currentSlide < self.totalSlides - 1) {
        self.goForward();
      }
      break;
    }
  });
}

Slider.prototype.getSlideNo = function (offset) {
  if (!offset) {
    return this.currentSlide;
  }

  if (this.currentSlide + offset < 0) {
    return this.totalSlides - 1;
  } else if (this.currentSlide + offset >= this.totalSlides) {
    return 0;
  } else {
    return this.currentSlide + offset;
  }
};


Slider.prototype.updateState = function (dontAnimate, dontPreload) {
  var duration = 100;

  dontPreload = dontPreload || false;

  if (this.currentSlide === 0 && this.backIsVisible) {
    if (dontAnimate) {
      this.$back.hide();
    } else {
      this.$back.velocity('fadeOut', { duration: duration });
    }
    this.backIsVisible = false;
  } else if (!this.backIsVisible) {
    if (dontAnimate) {
      this.$back.show();
    } else {
      this.$back.velocity('fadeIn', { duration: duration });
    }
    this.backIsVisible = true;
  }

  if (this.currentSlide === this.totalSlides - 1 && this.forwardIsVisible) {
    if (dontAnimate) {
      this.$forward.hide();
    } else {
      this.$forward.velocity('fadeOut', { duration: duration });
    }
    this.forwardIsVisible = false;
  } else if (!this.forwardIsVisible) {
    if (dontAnimate) {
      this.$forward.show();
    } else {
      this.$forward.velocity('fadeIn', { duration: duration });
    }
    this.forwardIsVisible = true;
  }

  // Expanded or not
  if (this.currentSlide === 0) {
    this.$el.removeClass('is-expanded');
  } else {
    this.$el.addClass('is-expanded');
  }

  // Preload
  if (!dontPreload) {
    this.preloadNext();
  }
};

Slider.prototype.preloadNext = function () {
  var nextSlide = this.$slides.eq(this.getSlideNo(1)).filter('[data-src]');
  if (nextSlide.length > 0) {
    nextSlide
      .css('background-image', 'url(' + nextSlide.attr('data-src') + ')')
      .removeAttr('data-src');
  }
};

Slider.prototype.goBack = function () {
  var nextSlide = this.getSlideNo(-1),
      self = this;

  if (nextSlide === this.currentSlide) {
    return;
  }

  if (this.isAnimating) {
    return;
  }

  if (nextSlide === 0) {
    this.transitionHeight();
  }

  this.$slides.eq(this.currentSlide).velocity({
    'translateX': ['100%', '0']
  }, {
    duration: this.duration,
    easing: this.easing,
    display: 'none'
  });

  this.$slides.eq(nextSlide).velocity({
    'translateX': ['0', '-100%']
  },{
    duration: this.duration,
    easing: this.easing,
    display: 'block',
    begin: function () {
      self.isAnimating = true;
    },
    complete: function () {
      self.isAnimating = false;
    }
  });
  this.currentSlide = nextSlide;
  this.updateState();
};


Slider.prototype.goForward = function () {
  var nextSlide = this.getSlideNo(1),
      self = this;

  if (nextSlide === this.currentSlide) {
    return;
  }

  if (this.isAnimating) {
    return;
  }

  this.preloadNext();

  if (nextSlide === 1) {
    this.transitionHeight();
  }

  this.$slides.eq(this.currentSlide).velocity({
    'translateX': ['-100%', '0']
  }, {
    duration: this.duration,
    easing: this.easing,
    display: 'none'
  });
  this.$slides.eq(nextSlide).velocity({
    'translateX': ['0', '100%']
  },{
    duration: this.duration,
    easing: this.easing,
    display: 'block',
    begin: function () {
      self.isAnimating = true;
    },
    complete: function () {
      self.isAnimating = false;
    }
  });

  this.currentSlide = nextSlide;
  this.updateState();
};

Slider.prototype.transitionHeight = function () {
  var self = this;
  var handleTransitionEnd = function(ev) {
    if (ev.originalEvent.propertyName === 'height') {
      self.$el.off('transitionend', handleTransitionEnd);
      self.$el.css('transition', '');
    }
  };

  this.$el.on('transitionend', handleTransitionEnd);
  this.$el.css('transition', 'height ' + this.duration + 'ms ease');
}

$(function () {
  var $slider = $('.js-slider'),
      slider;

  if ($slider.length > 0) {
    slider = new Slider($slider);

    window.P5 = window.P5 || {};
    window.P5.slider = slider;
  }
});
